import React from 'react';
import {handleClick} from './utilities';

export const Tags = ({tagList, context}) => {
  return tagList?.map((element, i) => {
    return (
      <button
        key={i}
        style={{
          cursor: element?.link ? 'pointer' : 'default',
        }}
        onClick={() => element?.link && handleClick(element?.link, context)}
        className='tags-buttons'>
        {element?.tagText}
      </button>
    );
  });
};
